module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.8539/img/favicon.png"